import BaseResource from './index'
import UserResource from './user'

export default class ImageResource extends BaseResource {
    static endpoint = '/images'
    static cacheMaxAge = 3600
    static related() {
        return {
            owner: UserResource
        }
    }

    toString() {
        return this.attributes.url
    }
}
